import { useEffect, useState, useContext } from "react";
import { Button } from "@mui/material";
import InputText from "../../../shared/components/inputs/InputText/InputText";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { AuthContext } from "../../../shared/context/auth-context";
import { Popconfirm } from "antd";
import ErrorIcon from "@mui/icons-material/Error";
import PageviewIcon from "@mui/icons-material/Pageview";
import toast from "react-hot-toast";
import codigoPaises from "../../clientes/components/codigoPaises";
import Autocomplete from "@mui/material/Autocomplete";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import { TextField } from "@mui/material";
import { useLoading } from "../../../shared/context/LoadingContext";
import { ClinicaContext } from "../../../shared/context/clinica-context";

import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import InputLabel from "@mui/material/InputLabel";

import { Collapse, IconButton, Paper, Divider } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import SearchIcon from "@mui/icons-material/Search";
import { CircularProgress } from "@mui/material";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import NotaPartilhaUnidades from "../components/NotaPartilhaUnidades";

/* O valor gravado e o nome que se mostra são diferentes: na base o tipo é
 * `despesa`, mas em todo o lado da aplicação isto chama-se «Saída».
 *
 * A tabela existe porque o campo mostrava as duas coisas ao mesmo tempo — a
 * lista dizia «Saída», e assim que se escolhia, o campo fechado passava a
 * dizer «despesa». Era o `renderValue` a juntar os valores crus em vez das
 * etiquetas. Com a tradução num sítio só, os dois leem do mesmo lado. */
const TIPOS_FORNECEDOR = [
  { valor: "despesa", etiqueta: "Saída" },
  { valor: "stock", etiqueta: "Stock" },
];

const etiquetaDoTipo = (valor) =>
  TIPOS_FORNECEDOR.find((t) => t.valor === valor)?.etiqueta || valor;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
      color: "#0c53fb",
    },
  },
};

function Fornecedores({ sendRequest, clinicaId }) {
  const { startLoading, stopLoading } = useLoading();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [nomeFornecedor, setNomeFornecedor] = useState("");
  const [nifFornecedor, setNifFornecedor] = useState("");
  const [contactoFornecedor, setContactoFornecedor] = useState("");
  const [enderecoFornecedor, setEnderecoFornecedor] = useState("");
  const [emailFornecedor, setEmailFornecedor] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [idFornecedor, setIdFornecedor] = useState(null);
  const [fornecedores, setFornecedores] = useState([]);
  const [mensagemDeErro, setMensagemDeErro] = useState("");
  const [pais, setPais] = useState({ nome: "CABO VERDE", codigo: "CV" });
  const [tipos, setTipos] = useState([]);
  const auth = useContext(AuthContext);

  const clinica = useContext(ClinicaContext);

  const [expandedSearch, setExpandedSearch] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchingByName, setSearchingByName] = useState(false);

  useEffect(() => {
    const fetchFornecedores = async () => {
      startLoading();
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/fornecedores/clinica/${clinicaId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
        setFornecedores(responseData.fornecedores);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };
    fetchFornecedores();
  }, [auth.token, clinicaId, sendRequest]);

  const nomeFornecedorChangeHandler = (valor) => {
    setNomeFornecedor(valor);
  };

  const nifFornecedorChangeHandler = (valor) => {
    setNifFornecedor(valor);
  };

  const contactoFornecedorChangeHandler = (valor) => {
    setContactoFornecedor(valor);
  };

  const enderecoFornecedorChangeHandler = (valor) => {
    setEnderecoFornecedor(valor);
  };

  const emailFornecedorChangeHandler = (valor) => {
    setEmailFornecedor(valor);
  };

  // Custom option rendering function
  const renderOption = (props, option) => (
    <Box
      component="span"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        padding: "8px",
      }}
      {...props}
    >
      <Typography variant="subtitle1">{option.nome}</Typography>
      <Typography variant="body2" color="textSecondary">
        {option.codigo}
      </Typography>
    </Box>
  );

  const guardarFornecedor = async () => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("nome", nomeFornecedor);
      formData.append("contacto", contactoFornecedor);
      formData.append("nif", nifFornecedor);
      formData.append("email", emailFornecedor);
      formData.append("endereco", enderecoFornecedor);
      formData.append("pais", JSON.stringify(pais));
      formData.append("clinica", clinicaId);
      formData.append("criadoPor", auth.userId);
      formData.append("tipo", JSON.stringify(tipos));

      const fornecedorCriado = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/fornecedores/`,
        "POST",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      setFornecedores((current) => [...current, fornecedorCriado.fornecedor]);

      resetarValores();

      setOpenModal(false);
      setIdFornecedor(null);

      toast.success("Fornecedor criado com sucesso!");
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
    setIsSubmitting(false);
  };

  const editarFornecedor = async (id) => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("nome", nomeFornecedor);
      formData.append("contacto", contactoFornecedor);
      formData.append("nif", nifFornecedor);
      formData.append("email", emailFornecedor);
      formData.append("endereco", enderecoFornecedor);
      formData.append("pais", JSON.stringify(pais));
      formData.append("atualizadoPor", auth.userId);
      formData.append("tipo", JSON.stringify(tipos));

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/fornecedores/${id}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      const fornecedorrCopy = [...fornecedores];
      const fornecedoresModificadas = fornecedorrCopy.map((clf) => {
        if (clf.id === id) {
          return {
            id: id,
            _id: id,
            nome: nomeFornecedor,
            contacto: contactoFornecedor,
            nif: nifFornecedor,
            endereco: enderecoFornecedor,
            pais: pais,
            email: emailFornecedor,
            tipo: tipos,
          };
        } else {
          return clf;
        }
      });

      setFornecedores([...fornecedoresModificadas]);

      resetarValores();
      setIdFornecedor(null);
      setOpenModal(false);

      toast.success("Fornecedor modificado com sucesso!");
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
    setIsSubmitting(false);
  };

  const preEditarFornecedor = async (id) => {
    setIdFornecedor(id);
    const fornecedorFiltrado = fornecedores.filter((cat) => cat.id === id)[0];

    setNomeFornecedor(fornecedorFiltrado.nome);
    setContactoFornecedor(fornecedorFiltrado.contacto);
    setNifFornecedor(fornecedorFiltrado.nif);
    setEnderecoFornecedor(fornecedorFiltrado.endereco);
    setEmailFornecedor(fornecedorFiltrado.email);
    /* Nem todos os fornecedores têm país. Os criados por escrita livre numa
       saída nascem só com o nome, e sem esta alternativa o `pais` ficava
       `undefined` — o formulário lê `pais.nome` logo a seguir e rebentava com
       «Cannot read properties of undefined (reading 'nome')», sem se conseguir
       abrir a edição.

       O valor é o mesmo com que o formulário arranca num fornecedor novo. */
    setPais(fornecedorFiltrado.pais || { nome: "CABO VERDE", codigo: "CV" });
    setTipos(fornecedorFiltrado.tipo || []);
    setOpenModal(true);
  };

  const handleModalClose = () => {
    setMensagemDeErro("");
    setIdFornecedor(null);
    setOpenModal(false);
    resetarValores();
  };

  const resetarValores = () => {
    setNomeFornecedor("");
    setNifFornecedor("");
    setContactoFornecedor("");
    setEmailFornecedor("");
    setEnderecoFornecedor("");
    setPais({ nome: "CABO VERDE", codigo: "CV" });
    setTipos([]);
  };

  const desativarFornecedor = async (id) => {
    startLoading();
    try {
      const formDataDesativar = new FormData();
      formDataDesativar.append("utilizador", auth.userId);

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/fornecedores/toggleativo/${id}`,
        "PATCH",
        formDataDesativar,
        {
          Authorization: "Bearer " + auth.token,
        },
      );
      setFornecedores((current) => current.filter((forn) => forn.id !== id));

      toast.success("Fornecedor desativado com sucesso!");
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  const validateTelefoneField = (value) => {
    const digitPattern = /^\d{7}$/;
    return digitPattern.test(value.replace(/\s/g, ""));
  };

  const beforeSubmit = (idFornecedor) => {
    let haErro = false;

    let duplicidadeFornecedor = false;
    if (idFornecedor) {
      duplicidadeFornecedor = fornecedores.filter(
        (c) =>
          c._id !== idFornecedor &&
          c.nome.toLowerCase() === nomeFornecedor.trim().toLowerCase(),
      );
    }

    if (
      !nomeFornecedor ||
      nomeFornecedor.trim() === "" ||
      !contactoFornecedor ||
      contactoFornecedor.trim() === "" ||
      !nifFornecedor ||
      nifFornecedor === "" ||
      !enderecoFornecedor ||
      enderecoFornecedor.trim() === "" ||
      !pais
    ) {
      setMensagemDeErro("Preencha todos os campos assinalados com *");
      haErro = true;
    } else if (idFornecedor && duplicidadeFornecedor?.length > 0) {
      setMensagemDeErro("Já existe um Fornecedor com esse nome.");
      haErro = true;
    } else if (!tipos || tipos.length === 0) {
      haErro = true;
      setMensagemDeErro("Deve escolher pelo menos 1 tipo de fornecedor");
    } else if (!validateTelefoneField) {
      setMensagemDeErro(
        "O contacto deve ser apenas valores numéricos de 7 digitos e sem espaços",
      );
    } else {
      setMensagemDeErro("");
    }

    if (!isSubmitting && !haErro) {
      setIsSubmitting(true);
      if (idFornecedor) {
        editarFornecedor(idFornecedor);
      } else {
        guardarFornecedor();
      }
    }
  };

  const findClientInfo = async () => {
    startLoading();
    if (pais.nome !== "CABO VERDE") {
      toast.error("Procura por nif só para Cabo Verde");
    } else {
      if (!nifFornecedor || nifFornecedor === "") {
        toast.error("Preencha o campo do nif");
      } else {
        const formData = new FormData();
        formData.append("nif", nifFornecedor);

        try {
          const response = await sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/documentoeletronico/nifbinome`,
            "PATCH",
            formData,
            {
              Authorization: "Bearer " + auth.token,
            },
          );

          if (!response?.payload) {
            toast.error("Nenhuma resposta da efatura");
          } else if (response.payload.length === 0) {
            toast.error("Nenhum cliente encontrado");
          } else if (response.payload.length === 1) {
            toast.success("Cliente encontrado");
            setNomeFornecedor(response.payload[0].Name);
            setNifFornecedor(response.payload[0].TaxId);
          }
        } catch (err) {
          console.error("err", err);
        } finally {
          stopLoading();
        }
      }
    }
  };

  const tiposChangeHandler = (event) => {
    const {
      target: { value },
    } = event;
    setTipos(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value,
    );
  };

  // Função para buscar por nome
  const searchByName = async () => {
    if (!searchTerm || searchTerm.trim() === "") {
      toast.error("Digite um nome para buscar");
      return;
    }

    if (pais.nome !== "CABO VERDE") {
      toast.error("Procura por nome só para Cabo Verde");
      return;
    }

    setSearchingByName(true);
    const formData = new FormData();
    formData.append("nome", searchTerm);

    try {
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/documentoeletronico/nifbinome`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      if (!response?.payload) {
        toast.error("Nenhuma resposta da efatura");
      } else if (response.payload.length === 0) {
        toast.error("Nenhum cliente encontrado");
        setSearchResults([]);
      } else {
        setSearchResults(response.payload);
        setExpandedSearch(true);
      }
    } catch (err) {
      console.error("Erro na busca:", err);
      toast.error("Erro ao buscar cliente");
    } finally {
      setSearchingByName(false);
    }
  };

  const selectClientFromSearch = (cliente) => {
    setNomeFornecedor(cliente.Name);
    setNifFornecedor(cliente.TaxId);
    setExpandedSearch(false);
    setSearchResults([]);
    setSearchTerm("");
  };

  return (
    <>
      <div className="categoriasFinanceiro__container">
        {(auth.role === "Médico/Administrador" || auth.role === "Gerente") && (
          <div
            className="categoriasFinanceiro__container__btn-adicionar"
            style={{ width: "240px" }}
          >
            <Button
              variant="contained"
              color="success"
              onClick={(e) => setOpenModal(true)}
            >
              Novo Fornecedor
            </Button>
          </div>
        )}

        <div
          style={{
            backgroundColor: "#e3f2fd",
            border: "1px solid #90caf9",
            borderRadius: "8px",
            padding: "16px 20px",
            marginBottom: "20px",
            display: "flex",
            gap: "15px",
            alignItems: "flex-start",
            gridColumn: "1/-1",
            margin: "30px",
          }}
        >
          <InfoOutlinedIcon style={{ color: "#1976d2", marginTop: "2px" }} />
          <div
            style={{ fontSize: "14px", color: "#1565c0", lineHeight: "1.6" }}
          >
            <strong
              style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "15px",
              }}
            >
              Como funcionam os Fornecedores?
            </strong>
            <ul style={{ margin: 0, paddingLeft: "18px" }}>
              <li>
                Registe fornecedores para associar a compras de stock ou saídas
                financeiras.
              </li>
              <li>
                Um fornecedor pode ser do tipo <strong>Stock</strong>,{" "}
                <strong>Saídas</strong> ou <strong>Ambos</strong>.
              </li>
              <li>Os dados do fornecedor são utilizados em relatórios.</li>
              <NotaPartilhaUnidades />
            </ul>
          </div>
        </div>

        <div className="categoriasFinanceiro__row">
          <span className="categoriasFinanceiro__titulo">Ambas</span>
          {fornecedores &&
            fornecedores.map(
              (fornecedor, index) =>
                fornecedor.tipo.length === 2 && (
                  <div
                    className="categoriasFinanceiro__container__categoria"
                    key={index}
                  >
                    <div className="categoriasFinanceiro__container__categoria--1">
                      {fornecedor.nome}
                    </div>
                    <div className="categoriasFinanceiro__container__categoria--2">
                      {(auth.role === "Médico/Administrador" ||
                        auth.role === "Gerente") &&
                        fornecedor.nome.toUpperCase() !==
                          "INSTITUTO NACIONAL DE PREVIDENCIA SOCIAL" && (
                          <Popconfirm
                            title={`Desativar Fornecedor`}
                            description={`Confirma desativação do Fornecedor?`}
                            icon={<ErrorIcon style={{ color: "red" }} />}
                            okText="Sim"
                            cancelText="Não"
                            onConfirm={desativarFornecedor.bind(
                              null,
                              fornecedor.id,
                            )}
                            className="popConfirm--biggerPadding"
                          >
                            <span>Desativar</span>
                          </Popconfirm>
                        )}
                      {(auth.role === "Médico/Administrador" ||
                        auth.role === "Gerente") &&
                        fornecedor.nome.toUpperCase() !==
                          "INSTITUTO NACIONAL DE PREVIDENCIA SOCIAL" && (
                          <span
                            onClick={preEditarFornecedor.bind(
                              null,
                              fornecedor.id,
                            )}
                          >
                            Editar
                          </span>
                        )}
                    </div>
                  </div>
                ),
            )}
        </div>

        <div className="categoriasFinanceiro__row">
          <span className="categoriasFinanceiro__titulo">Saída</span>
          {fornecedores &&
            fornecedores.map(
              (fornecedor, index) =>
                fornecedor.tipo.length === 1 &&
                fornecedor.tipo[0] === "despesa" && (
                  <div
                    className="categoriasFinanceiro__container__categoria"
                    key={index}
                  >
                    <div className="categoriasFinanceiro__container__categoria--1">
                      {fornecedor.nome}
                    </div>
                    <div className="categoriasFinanceiro__container__categoria--2">
                      {(auth.role === "Médico/Administrador" ||
                        auth.role === "Gerente") &&
                        fornecedor.nome.toUpperCase() !==
                          "INSTITUTO NACIONAL DE PREVIDENCIA SOCIAL" && (
                          <Popconfirm
                            title={`Desativar Fornecedor`}
                            description={`Confirma desativação do Fornecedor?`}
                            icon={<ErrorIcon style={{ color: "red" }} />}
                            okText="Sim"
                            cancelText="Não"
                            onConfirm={desativarFornecedor.bind(
                              null,
                              fornecedor.id,
                            )}
                            className="popConfirm--biggerPadding"
                          >
                            <span>Desativar</span>
                          </Popconfirm>
                        )}
                      {(auth.role === "Médico/Administrador" ||
                        auth.role === "Gerente") &&
                        fornecedor.nome.toUpperCase() !==
                          "INSTITUTO NACIONAL DE PREVIDENCIA SOCIAL" && (
                          <span
                            onClick={preEditarFornecedor.bind(
                              null,
                              fornecedor.id,
                            )}
                          >
                            Editar
                          </span>
                        )}
                    </div>
                  </div>
                ),
            )}
        </div>

        <div className="categoriasFinanceiro__row">
          <span className="categoriasFinanceiro__titulo">Stock</span>
          {fornecedores &&
            fornecedores.map(
              (fornecedor, index) =>
                fornecedor.tipo.length === 1 &&
                fornecedor.tipo[0] === "stock" && (
                  <div
                    className="categoriasFinanceiro__container__categoria"
                    key={index}
                  >
                    <div className="categoriasFinanceiro__container__categoria--1">
                      {fornecedor.nome}
                    </div>
                    <div className="categoriasFinanceiro__container__categoria--2">
                      {(auth.role === "Médico/Administrador" ||
                        auth.role === "Gerente") &&
                        fornecedor.nome.toUpperCase() !==
                          "INSTITUTO NACIONAL DE PREVIDENCIA SOCIAL" && (
                          <Popconfirm
                            title={`Desativar Fornecedor`}
                            description={`Confirma desativação do Fornecedor?`}
                            icon={<ErrorIcon style={{ color: "red" }} />}
                            okText="Sim"
                            cancelText="Não"
                            onConfirm={desativarFornecedor.bind(
                              null,
                              fornecedor.id,
                            )}
                            className="popConfirm--biggerPadding"
                          >
                            <span>Desativar</span>
                          </Popconfirm>
                        )}
                      {(auth.role === "Médico/Administrador" ||
                        auth.role === "Gerente") &&
                        fornecedor.nome.toUpperCase() !==
                          "INSTITUTO NACIONAL DE PREVIDENCIA SOCIAL" && (
                          <span
                            onClick={preEditarFornecedor.bind(
                              null,
                              fornecedor.id,
                            )}
                          >
                            Editar
                          </span>
                        )}
                    </div>
                  </div>
                ),
            )}
        </div>

        <Modal
          open={openModal}
          onClose={handleModalClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            className="fluxo-atendimento__modal__box adicionar-categoria__modal"
            id="modal__adicionar-categoria"
          >
            <h1 className="fluxo-atendimento__modal__titulo">Fornecedor</h1>
            <div
              className="adicionar-categoria__modal__container"
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <Paper
                elevation={0}
                sx={{
                  border: "1px solid #e0e0e0",
                  borderRadius: 2,
                  p: 2,
                  mb: 2,
                  backgroundColor: "#f5f5f5",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                    Buscar Fornecedor
                  </Typography>
                  <IconButton
                    onClick={() => setExpandedSearch(!expandedSearch)}
                    size="small"
                  >
                    {expandedSearch ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </IconButton>
                </Box>

                <Collapse in={expandedSearch}>
                  <Divider sx={{ my: 1 }} />

                  {/* Campo de busca por nome */}
                  <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
                    <TextField
                      size="small"
                      fullWidth
                      label="Buscar por nome"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onKeyPress={(e) => e.key === "Enter" && searchByName()}
                      disabled={pais.nome !== "CABO VERDE"}
                      helperText={
                        pais.nome !== "CABO VERDE"
                          ? "Disponível apenas para Cabo Verde"
                          : ""
                      }
                    />
                    <IconButton
                      onClick={searchByName}
                      disabled={searchingByName || pais.nome !== "CABO VERDE"}
                      sx={{
                        backgroundColor: "#175c93",
                        color: "white",
                        "&:hover": { backgroundColor: "#124670" },
                      }}
                    >
                      {searchingByName ? (
                        <CircularProgress size={20} />
                      ) : (
                        <SearchIcon />
                      )}
                    </IconButton>
                  </Box>

                  {/* Resultados da busca */}
                  {searchResults.length > 0 && (
                    <Box sx={{ mt: 2, maxHeight: 200, overflowY: "auto" }}>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        sx={{ mb: 1 }}
                      >
                        {searchResults.length} resultado(s) encontrado(s):
                      </Typography>
                      {searchResults.map((cliente, index) => (
                        <Paper
                          key={index}
                          sx={{
                            p: 1.5,
                            mb: 1,
                            cursor: "pointer",
                            "&:hover": { backgroundColor: "#e3f2fd" },
                            border: "1px solid #e0e0e0",
                          }}
                          onClick={() => selectClientFromSearch(cliente)}
                        >
                          <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {cliente.Name}
                          </Typography>
                          <Typography variant="caption" color="textSecondary">
                            NIF: {cliente.TaxId}{" "}
                            {cliente.BI ? `| BI: ${cliente.BI}` : ""}
                          </Typography>
                        </Paper>
                      ))}
                    </Box>
                  )}
                </Collapse>
              </Paper>

              <InputText
                className="adicionar-categoria__modal__container--span2"
                label="Nome do Fornecedor *"
                initialValue={nomeFornecedor}
                handleChange={nomeFornecedorChangeHandler}
                id="1"
              />
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "90% 10%",
                  gap: 0,
                }}
              >
                <InputText
                  className="adicionar-categoria__modal__container--span2"
                  label="Nif do Fornecedor *"
                  initialValue={nifFornecedor}
                  handleChange={nifFornecedorChangeHandler}
                  id="2"
                />
                <PageviewIcon
                  style={{
                    fontSize: "63px",
                    cursor: "pointer",
                    fill: "#175c93",
                  }}
                  onClick={findClientInfo}
                />
              </div>

              <InputText
                className="adicionar-categoria__modal__container--span2"
                label="Contacto do Fornecedor *"
                initialValue={contactoFornecedor}
                handleChange={contactoFornecedorChangeHandler}
                id="3"
              />

              <FormControl
                style={{ width: "100%" }}
                className="adicionar-categoria__modal__container--span2"
              >
                <Autocomplete
                  id="codPais"
                  value={pais}
                  onChange={(e, value) => setPais(value)}
                  options={codigoPaises}
                  getOptionLabel={(option) =>
                    `${option.nome} - ${option.codigo}`
                  }
                  renderOption={renderOption}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Pais"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </FormControl>

              <InputText
                className="adicionar-categoria__modal__container--span2"
                label="Endereco do Fornecedor *"
                initialValue={enderecoFornecedor}
                handleChange={enderecoFornecedorChangeHandler}
                id="4"
              />

              <FormControl
                sx={{ m: 1 }}
                style={{ width: "100%", margin: "25px 0 0 0 " }}
              >
                <InputLabel id="demo-multiple-checkbox-label">Tipos</InputLabel>
                <Select
                  id="demo-multiple-checkbox"
                  multiple
                  value={tipos}
                  onChange={tiposChangeHandler}
                  input={<OutlinedInput label="Tipos*" />}
                  renderValue={(selected) =>
                    selected.map(etiquetaDoTipo).join(", ")
                  }
                  MenuProps={MenuProps}
                  style={{ color: "#0c53fb" }}
                >
                  {TIPOS_FORNECEDOR.map((t) => (
                    <MenuItem key={t.valor} value={t.valor}>
                      <Checkbox checked={tipos.indexOf(t.valor) > -1} />
                      <ListItemText primary={t.etiqueta} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <InputText
                className="adicionar-categoria__modal__container--span2"
                label="Email do Fornecedor"
                initialValue={emailFornecedor}
                handleChange={emailFornecedorChangeHandler}
                id="5"
              />
            </div>

            {mensagemDeErro && (
              <div className="erroContainer__categoria-caixa">
                {mensagemDeErro}
              </div>
            )}

            <div className="fluxo-atendimento__modal__bottom_btns">
              <span
                className="cancel-btn"
                onClick={handleModalClose}
                style={{ display: "block" }}
              >
                Fechar
              </span>

              <span
                disabled={isSubmitting}
                className="blue-button"
                onClick={
                  idFornecedor
                    ? beforeSubmit.bind(null, idFornecedor)
                    : beforeSubmit.bind(null, null)
                }
              >
                {idFornecedor
                  ? isSubmitting
                    ? "Guardando"
                    : "Guardar"
                  : isSubmitting
                    ? "Guardando"
                    : "Guardar"}
              </span>
            </div>
          </Box>
        </Modal>
      </div>
    </>
  );
}

export default Fornecedores;
